import { render, staticRenderFns } from "./MontantComponent.vue?vue&type=template&id=b27cd6c0"
import script from "./MontantComponent.vue?vue&type=script&lang=js"
export * from "./MontantComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports